module.exports = __webpack_public_path__ + "img/face10.d380c56d.gif";